import { UserCommunication } from '@this+that/models';

import { ShortcutContext } from './types';
import { useEmailListNavigation } from './useEmailListNavigation';

interface UseTrashNavigationProps {
  filteredCommunications: UserCommunication[];
}

export function useTrashNavigation({
  filteredCommunications,
}: UseTrashNavigationProps) {
  return useEmailListNavigation({
    filteredCommunications,
    context: ShortcutContext.TRASH,
  });
}
